<script setup lang="ts">
import ColoredText from '@/components/ColoredText.vue';
import DefaultChip from '../components/DefaultChip.vue';

import { useCalculatorEstimated } from '../composables/useCalculatorEstimated';

const { calculationRules } = useCalculatorEstimated();
</script>

<template>
  <div class="space-y-1">
    <div class="font-bold text-gray-900">Podsumowanie kalkulacji</div>

    <div
      :key="rule.id"
      v-for="rule in calculationRules"
      class="flex items-center justify-between gap-4 py-3.5 text-sm font-medium text-gray-iron-700"
    >
      <ColoredText :variant="rule.color">{{ rule.name }}</ColoredText>

      <DefaultChip :variant="rule.color"> {{ rule.eval }} {{ rule.unit }}</DefaultChip>
    </div>
  </div>
</template>
